import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { ListBonusComponentsResponse, ListBonusComponentsVariables } from '../types';

export const listBonusComponentsQuery = gql`
  query ListBonusComponents($input: ListSalaryComponentsInput!) {
    payrollListFlexibleBenefitsComponents(input: $input) {
      code
      success
      message
      total_count
      data {
        id
        name
        description
        is_active
        settings {
          flexible_settings {
            tax_behaviour {
              tax_deduction_behaviour
            }
          }
        }
      }
    }
  }
`;

export const listBonusComponents = (queryVariables: ListBonusComponentsVariables) =>
  graphQLApi<ListBonusComponentsResponse, ListBonusComponentsVariables>({
    query: listBonusComponentsQuery,
    queryVariables,
  });

export default listBonusComponents;
